export const GET_TESTCENTERS = "GET_TESTCENTERS";
export const SET_MAP = "SET_MAP";
export const ADD_TESTCENTER = "ADD_TESTCENTER";
export const UPDATE_TESTCENTER = "UPDATE_TESTCENTER";
export const GET_TESTCENTER = "GET_TESTCENTER";
export const DELETE_TESTCENTER = "DELETE_TESTCENTER";
export const TESTCENTER_ERROR = "TESTCENTER_ERROR";

export const GET_VACCINECENTERS = "GET_VACCINECENTERS";
export const ADD_VACCINECENTER = "ADD_VACCINECENTER";
export const UPDATE_VACCINECENTER = "UPDATE_VACCINECENTER";
export const GET_VACCINECENTER = "GET_VACCINECENTER";
export const DELETE_VACCINECENTER = "DELETE_VACCINECENTER";
export const VACCINECENTER_ERROR = "VACCINECENTER_ERROR";

export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
